// src/features/dashboard/hooks/useLiveClock.ts
import { useEffect, useState } from 'react';

const dateFormatter = new Intl.DateTimeFormat('fa-IR', {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});

const timeFormatter = new Intl.DateTimeFormat('fa-IR', {
  hour: '2-digit',
  minute: '2-digit',
});

/**
 * Ticking clock formatted for the Persian locale.
 * Updates once a minute -- plenty for a "current date/time" header, and
 * cheap enough not to fight the count-up / chart animations for frames.
 */
export function useLiveClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(interval);
  }, []);

  return {
    now,
    dateLabel: dateFormatter.format(now),
    timeLabel: timeFormatter.format(now),
  };
}
